<div [ngClass]="isPdfShowing ? 'pdf-visible' : 'upload-card'">
    <mat-card *ngIf="document?.displayName">
        <div class="upload-card-body">
            <h2>{{ document.displayName }}</h2>
            <div class="upload-card-actions pdf-column">
                <button class="desktop-view-btn" mat-button type="button" (click)="uploadFile.click()">Select an Image or PDF</button>
                <button class="mobile-view-btn" mat-button type="button" (click)="uploadFile.click()">Select Image or Take Photo</button>
                <input #uploadFile type="file" accept=".jpeg,.jpg,.png,.pdf" (change)="selectPdf($event.target['files'][0])" />
            </div>
        </div>
    </mat-card>
</div>
<!-- IMAGE UPLOAD -->
<ng-container *ngIf="isPdfShowing">
    <section>
        <pdf-view
            [dealId]="dealId"
            [docId]="docId"
            [document]="uploadFile"
            [uploadFileDocumentType]="internalDocumentTypeId"
            [fileNameToSave]="fileNameToSave"
            [template]="template"
            [allowGuidedSigning]="false"
            (outEvent)="eventHandler($event)"
        >
        </pdf-view>
    </section>
</ng-container>

<ddj-spinner *ngIf="isLoading && !isIdentification"></ddj-spinner>
<ddj-license-spinner *ngIf="isLoading && isIdentification"></ddj-license-spinner>
